export default {
    // 测试环境
    // baseURL: 'http://192.168.3.16:8886',
    systemURL:window.config.systemURL,
    patrolURL: window.config.patrolURL,
    baseURL: window.config.baseURL,
    wxURL: window.config.wxURL,
    shareURL: window.config.shareURL,
    ignoreURL: window.config.ignoreURL,
    bindWechat:  window.config.bindWechat,
    resetWechat:  window.config.resetWechat,
    AIControl: window.config.AIControl,
    socketURL: window.config.socketURL,
    downDetail: window.config.downDetail
    // 预发布
    // baseURL: 'http://192.168.3.33:8885',
    // wxURL: 'http://www.ijiaodui.com:19666/signin/wx_pre_online?login-type-flag=web',
    // shareURL: 'http://192.168.3.33:9009/upload/detail?id=',
    // ignoreURL: 'https://www.ijiaodui.com:19555'
    
    // // 生产环境

    // baseURL: 'https://www.ijiaodui.com:19555',
    // wxURL: 'https://www.ijiaodui.com:19666/signin/wx_online?login-type-flag=web',
    // ignoreURL: 'https://www.ijiaodui.com:19555',
    // shareURL: 'https://www.ijiaodui.com/upload/detail?id=',
}